<template>
  <StatCard
    title="Avg. Order Value"
    :value="formattedValue"
    icon="receipt_long"
    icon-class="aov-icon"
    :trend="statsComparison.trend"
    :percentage="statsComparison.percentage"
    :comparison-period="comparisonPeriod"
  />
</template>

<script>
import StatCard from "./StatCard.vue";

export default {
  name: "AverageOrderValueCard",
  components: {
    StatCard
  },
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    statsComparison: {
      type: Object,
      default: () => ({ percentage: 0, trend: 'neutral' })
    },
    comparisonPeriod: {
      type: String,
      default: 'previous_period'
    }
  },
  computed: {
    formattedValue() {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(Number(this.value) || 0);
    }
  }
};
</script>
